import imageCompression from "browser-image-compression";
import {
  uploadFileToHeader,
  uploadFileToRow,
} from "../utils/fileUploadHelpers";

interface UploadParams {
  photo: string | null;
  clientDbId: number;
  module?: string;
  operationCode: string;
  rowNumber?: number;
  comment: string;
  locale: string;
  onRefresh: () => void;
  onClose: () => void;
  setPhoto: (val: string | null) => void;
  setComment: (val: string) => void;
}

/**
 * Suspaudžia ir įkelia nuotrauką į dokumento header arba row.
 */
export const handleUploadFile = async ({
  photo,
  clientDbId,
  module,
  operationCode,
  rowNumber,
  comment,
  locale,
  onRefresh,
  onClose,
  setPhoto,
  setComment,
}: UploadParams) => {
  if (!photo) return;

  // photo čia yra su prefiksu, todėl prieš siųsdami pašalinam
  const pureBase64 = photo.replace(/^data:image\/[a-zA-Z]+;base64,/, "");

  if (rowNumber !== undefined && rowNumber !== null) {
    await uploadFileToRow({
      clientDbId,
      module: module ?? "",
      operationCode,
      rowNumber: String(rowNumber),
      file: pureBase64,
      fileType: ".JPG",
      description: comment,
      locale,
    });
  } else {
    await uploadFileToHeader({
      clientDbId,
      module: module ?? "",
      operationCode,
      file: pureBase64,
      fileType: ".JPG",
      description: comment,
      locale,
    });
  }

  await onRefresh();
  onClose();

  setPhoto(null);
  setComment("");
};

/**
 * Pasirinkus nuotrauką iš disko – suspaudžia ir konvertuoja į base64.
 */
export const handleSelectFile = async (
  event: React.ChangeEvent<HTMLInputElement>,
  setPhoto: (val: string) => void,
  stopCameraFn: () => void,
  showError: (msg: string) => void
) => {
  const file = event.target.files?.[0];
  if (!file) return;

  // Leidžiami MIME tipai
  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
  if (!allowedTypes.includes(file.type)) {
    showError("Leidžiami tik JPG, JPEG ir PNG formato paveikslėliai");
    return;
  }

  // 10MB limitas
  const MAX_SIZE = 10 * 1024 * 1024;
  if (file.size > MAX_SIZE) {
    showError("Failas per didelis. Maksimalus dydis 10MB.");
    return;
  }

  const compressedFile = await imageCompression(file, {
    maxSizeMB: 1,
    maxWidthOrHeight: 800,
    useWebWorker: true,
  });

  // Čia paliekam su prefiksu, kad naršyklė galėtų rodyti
  const base64WithPrefix = await imageCompression.getDataUrlFromFile(
    compressedFile
  );

  setPhoto(base64WithPrefix);
  stopCameraFn();
};
